import { render, staticRenderFns } from "./ExpulsionOrderFormItemUsers.vue?vue&type=template&id=197d9e92&"
import script from "./ExpulsionOrderFormItemUsers.vue?vue&type=script&lang=ts&"
export * from "./ExpulsionOrderFormItemUsers.vue?vue&type=script&lang=ts&"
import style0 from "./ExpulsionOrderFormItemUsers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports